export default {
  emailLogs: [],
  emailLog: undefined,
};
